
<div class="row justify-content-center text-center">
    <div class="col-4 justify-content-center">
        <div class="card mt-3">
            <div class="card-body d-flex flex-column">
                <img class="altrad-logo-md my-3" [src]="'./assets/images/'+ sharedSvc.pafEnvironment.logo" />
                <div class="my-3 text-primary"><H5>Vous êtes déconnecté du portail fournisseurs</H5></div>
                <a routerLink="/login" class="text-primary mt-3 mb-1"><h5>Cliquez-sur ce lien pour vous reconnecter.</h5></a>
              
                
                 
            </div>
        </div>

    </div>
</div>